/* eslint-disable */
import axios, { CancelTokenSource } from 'axios';
import { Auth } from '@aws-amplify/auth';
// const storeNumber = window.sessionStorage.getItem('storeNumber');
const STORE_TIMEZONE_HEADER = 'store-timezone';

function getStoreTimezone(): string {
  try {
    const storeDetails = sessionStorage.getItem('storeDetails') || '';
    if (!storeDetails) return '';
    const decoded = Buffer.from(storeDetails, 'base64').toString('utf8');
    const parsedStoreDetails: any = JSON.parse(decoded);
    return parsedStoreDetails.storeTimezone || '';
  } catch {
    return '';
  }
}

async function getJWToken() {
  try {
    const currentSession = await Auth.currentSession();

    return currentSession.getIdToken().getJwtToken();
  } catch (error) {
    throw new Error(`An error occurred: ${error}.`);
  }
}

async function getAccessToken() {
  try {
    const currentSession = await Auth.currentSession();

    return currentSession.getAccessToken().getJwtToken();
  } catch (error) {
    throw new Error(`An error occurred: ${error}.`);
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export async function client(
  endpoint: string,
  { requestType, body, ...customConfig }: any = {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  apiUrl: any,
  // access token is required for accessing AM APIs, but not for general ones (e.g. user APIs)
  AccessToken = true
) {
  const jwtToken = await getJWToken();

  const headers: any = {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    'Content-Type': 'application/json; charset=UTF-8',
    storeNumber: window.sessionStorage.getItem('storeNumber'),
  };
  const timeZone = getStoreTimezone();
  if (timeZone) {
    headers[STORE_TIMEZONE_HEADER] = timeZone;
  }
  if (AccessToken) {
    const accessToken =
      window.localStorage.getItem('ac') || (await getAccessToken());
    headers.accessToken = accessToken;
    headers.storeNumber = window.sessionStorage.getItem('storeNumber');
  }
  if (jwtToken) {
    headers.Authorization = `Bearer ${jwtToken}`;
  }

  const requestConfig: any = {
    method: requestType,
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };

  if (body) {
    requestConfig.data = JSON.stringify(body);
  }

  return await axios(`${apiUrl}/${endpoint}`, requestConfig).then(
    (response) => response.data
  );
}

export async function client1(
  endpoint: string,
  { requestType, body, ...customConfig }: any = {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  apiUrl: any,
  // access token is required for accessing AM APIs, but not for general ones (e.g. user APIs)
  AccessToken?: string,
  needAccessToken = true
) {
  const jwtToken = await getJWToken();

  const headers: any = {
    'Content-Type': 'application/json; charset=UTF-8',
    storeNumber: window.sessionStorage.getItem('storeNumber'),
  };
  const timeZone = getStoreTimezone();
  if (timeZone) {
    headers[STORE_TIMEZONE_HEADER] = timeZone;
  }

  if (needAccessToken) {
    const accessToken =
      window.localStorage.getItem('ac') || (await getAccessToken());
    // eslint-disable-next-line no-console
    console.log('client access token', accessToken);
    // eslint-disable-next-line no-console
    console.log('GetPriceQuote Payload --->', body);
    headers.AccessToken = accessToken;
  }
  if (jwtToken) {
    headers.Authorization = `Bearer ${jwtToken}`;
  }

  const requestConfig: any = {
    method: requestType,
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };

  if (body) {
    requestConfig.data = JSON.stringify(body);
  }

  // eslint-disable-next-line no-console
  console.log('api url from app config', apiUrl);
  // eslint-disable-next-line no-console
  console.log('api request config', requestConfig);
  return await axios(`${apiUrl}/${endpoint}`, requestConfig).then(
    (response) => response.data
  );
}

export async function albCall(
  endpoint: string,
  { requestType, body, ...customConfig }: any = {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  apiUrl: any,
  // access token is required for accessing AM APIs, but not for general ones (e.g. user APIs)djvbh
  AccessToken?: string,
  needAccessToken = true
) {
  try {
    

    const headers: any = {
      'Content-Type': 'application/json; charset=UTF-8',
      storeNumber: window.sessionStorage.getItem('storeNumber'),
    };
    const timeZone = getStoreTimezone();
    if (timeZone) {
      headers[STORE_TIMEZONE_HEADER] = timeZone;
    }

    const accessToken =
      window.localStorage.getItem('ac') || (await getAccessToken());
    // eslint-disable-next-line no-console
    console.log('client access token', accessToken);
    // eslint-disable-next-line no-console
    console.log('GetPriceQuote Payload --->', body);
    headers.AccessToken = accessToken;
    
    
    headers.Authorization = `Bearer ${accessToken}`;
    

    const requestConfig: any = {
      method: requestType,
      ...customConfig,
      headers: {
        ...headers,
        ...customConfig.headers,
      },
    };

    if (body) {
      requestConfig.data = JSON.stringify(body);
    }

    // eslint-disable-next-line no-console
    console.log('api url from app config', apiUrl);
    // eslint-disable-next-line no-console
    console.log('api request config', requestConfig);
    return await axios(`${apiUrl}/${endpoint}`, requestConfig).then(
      (response) => response
    );
  } catch (e: any) {
    // eslint-disable-next-line no-console
    console.log('catch', e);
    // eslint-disable-next-line no-console
    console.log('catch response', e.response);
    return e.response;
  }
}


export async function clientCall(
  endpoint: string,
  { requestType, body, ...customConfig }: any = {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  apiUrl: any,
  // access token is required for accessing AM APIs, but not for general ones (e.g. user APIs)djvbh
  AccessToken?: string,
  needAccessToken = true
) {
  try {
    const jwtToken = await getJWToken();

    const headers: any = {
      'Content-Type': 'application/json; charset=UTF-8',
      storeNumber: window.sessionStorage.getItem('storeNumber'),
    };
    const timeZone = getStoreTimezone();
    if (timeZone) {
      headers[STORE_TIMEZONE_HEADER] = timeZone;
    }

    if (needAccessToken) {
      const accessToken =
        window.localStorage.getItem('ac') || (await getAccessToken());
      // eslint-disable-next-line no-console
      console.log('client access token', accessToken);
      // eslint-disable-next-line no-console
      console.log('GetPriceQuote Payload --->', body);
      headers.AccessToken = accessToken;
    }
    if (jwtToken) {
      headers.Authorization = `Bearer ${jwtToken}`;
    }

    const requestConfig: any = {
      method: requestType,
      ...customConfig,
      headers: {
        ...headers,
        ...customConfig.headers,
      },
    };

    if (body) {
      requestConfig.data = JSON.stringify(body);
    }

    // eslint-disable-next-line no-console
    console.log('api url from app config', apiUrl);
    // eslint-disable-next-line no-console
    console.log('api request config', requestConfig);
    return await axios(`${apiUrl}/${endpoint}`, requestConfig).then(
      (response) => response
    );
  } catch (e: any) {
    // eslint-disable-next-line no-console
    console.log('catch', e);
    // eslint-disable-next-line no-console
    console.log('catch response', e.response);
    return e.response;
  }
}

export async function externalCall(
  endpoint: string,
  { requestType, body, ...customConfig }: any = {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  apiUrl: any,
  
) {
  try {
    
    const headers: any = {
      'Content-Type': 'application/json; charset=UTF-8',
      storeNumber: window.sessionStorage.getItem('storeNumber'),
    };
    
    const requestConfig: any = {
      method: requestType,
      ...customConfig,
      headers: {
        ...headers,
        ...customConfig.headers,
      },
    };

    if (body) {
      requestConfig.data = JSON.stringify(body);
    }

    // eslint-disable-next-line no-console
    console.log('api url from app config', apiUrl);
    // eslint-disable-next-line no-console
    console.log('api request config', requestConfig);
    return await axios(`${apiUrl}/${endpoint}`, requestConfig).then(
      (response) => response
    );
  } catch (e: any) {
    // eslint-disable-next-line no-console
    console.log('catch', e);
    // eslint-disable-next-line no-console
    console.log('catch response', e.response);
    return e.response;
  }
}

export const getCancelTokenSource = (): CancelTokenSource =>
  axios.CancelToken.source();
